module.exports = __webpack_public_path__ + "img/1.aca8e20d.jpg";